import React from 'react';
import PropTypes from 'prop-types';

import styles from './Hero.m.sass';

import image1x from './assets/hero.png';
import imageMobile1x from './assets/hero-mobile.png';
import image2x from './assets/hero@2x.png';
import imageMobile2x from './assets/hero-mobile@2x.png';

export default class Hero extends React.PureComponent {
  render() {
    const {children} = this.props;

    return (
      <div className={styles.hero}>
        <div className={styles.row}>
          <div className={styles.content}>
            <h1 className={styles.header}>Prime quality boosting, <span className={styles.headerAccent}>fast&nbsp;and&nbsp;secure</span></h1>
            <div className={styles.buttons}>
              {children}
            </div>
          </div>
        </div>

        <div className={styles.image}>
          <picture>
            <source media="(min-width: 992px)" srcSet={`${image1x} 1x, ${image2x} 2x`}/>
            <source media="(max-width: 991px)" srcSet={`${imageMobile1x} 1x, ${imageMobile2x} 2x`}/>
            <img src={image1x} srcSet={`${image2x} 2x`} alt=""/>
          </picture>
        </div>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./components/hero/Hero.js